import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { RootState } from 'src/store';
import { progressSelectorFactory } from 'src/common/store/selectors';
import { ClientPortalSettings } from './components/ClientPortalSettings';
import { clientPortalSettingsSlice } from './store/slice';
import {
  ClientPortalSettingsTypes,
  fetchAfsls,
  fetchClientPortalSetting,
  saveClientPortalSetting,
  selectAfslId,
  selectAfsls,
  selectClientPortalSetting,
  selectHasUnsavedChanges,
} from './store';

const mapStateToProps = (state: RootState) => ({
  afsls: selectAfsls(state),
  afslId: selectAfslId(state),
  setting: selectClientPortalSetting(state),
  hasUnsavedChanges: selectHasUnsavedChanges(state),
  loadingProgress: progressSelectorFactory([ClientPortalSettingsTypes.FetchClientPortalSetting])(state),
  savingProgress: progressSelectorFactory([ClientPortalSettingsTypes.SaveClientPortalSetting])(state),
});

interface MatchParams {
  afslId: string;
}

const mapDispatchToProps = {
  ...clientPortalSettingsSlice.actions,

  fetchAfsls,
  fetchClientPortalSetting,
  saveClientPortalSetting,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector> & RouteComponentProps<MatchParams>;
export const ClientPortalSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(ClientPortalSettings);
